<ul>
  <li *ngFor="let item of inner_17025_Cat" class="MyMoeinListCat_Li">

    <div class="MyMoeinListCat_Div">
      <span class="MyMoeinListCat_Span">{{item.title}}</span>

      <i *ngIf="item.childVisible" class="fa fa-times-rectangle" style="visibility: visible !important;color: red;" (click)="Change_Visible(item)"></i>
      <i *ngIf="!item.childVisible" class="fa  fa-check-square" style="visibility: visible !important;color: green" (click)="Change_Visible(item)"></i>


    </div>


    <app-Protocol17025Cat_Co_Check
      (On_Change_Action)="Change_Visible($event)"
      [inner_17025_Cat]="item.child">

    </app-Protocol17025Cat_Co_Check>



  </li>
</ul>
